var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-waste-offer',[_vm._v("2222")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }